import React from 'react';
import {
  Box,
  FormGroup,
  FormControlLabel,
  Switch,
  Typography,
  Button,
  useTheme,
  alpha
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { readCookiePreferences, saveCookiePreferences } from '../../analytics/consent';

const CookieManager = ({ onSave }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  // Kayıtlı tercih varsa onu göster; yoksa analitik varsayılan kapalı (önceden işaretli kutu geçerli açık rıza sayılmaz)
  const [cookieSettings, setCookieSettings] = React.useState(() => {
    const stored = readCookiePreferences();
    return {
      essential: true,
      analytics: stored ? stored.analytics === true : false,
      // İşlevsel ve reklam çerezi kullanılmıyor (Çerez Politikası) — bu kategoriler her zaman kapalı kaydedilir
      functional: false,
      advertising: false
    };
  });

  const handleChange = (event) => {
    const { name, checked } = event.target;
    if (name === 'essential') return; // Essential cookies can't be disabled
    setCookieSettings(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const persist = (settings) => {
    if (onSave) {
      onSave(settings);
    } else {
      // localStorage + Google Consent Mode + sayfa takibi bildirimi
      saveCookiePreferences(settings);
      toast.success(t('cookies.manager.success'));
    }
  };

  const handleSave = () => persist(cookieSettings);

  // "Tümünü reddet" yalnızca anahtarları kapatmakla kalmaz, tercihi hemen kaydeder
  const handleRejectAll = () => {
    const rejected = { essential: true, analytics: false, functional: false, advertising: false };
    setCookieSettings(rejected);
    persist(rejected);
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: theme.palette.mode === 'dark'
          ? alpha(theme.palette.primary.main, 0.1)
          : alpha(theme.palette.primary.light, 0.1),
        borderRadius: 2,
        mt: 4
      }}
    >
      <Typography variant="h6" gutterBottom>
        {t('cookies.manager.title')}
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary" 
        paragraph
      >
        {t('cookies.manager.description')}
      </Typography>

      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={cookieSettings.essential}
              name="essential"
              disabled
            />
          }
          label={
            <Box>
              <Typography variant="subtitle2">
                {t('cookies.types.0.name')}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t('cookies.types.0.purpose')}
              </Typography>
            </Box>
          }
        />
        <FormControlLabel
          control={
            <Switch
              checked={cookieSettings.analytics}
              onChange={handleChange}
              name="analytics"
            />
          }
          label={
            <Box>
              <Typography variant="subtitle2">
                {t('cookies.types.1.name')}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t('cookies.types.1.purpose')}
              </Typography>
            </Box>
          }
        />
      </FormGroup>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
        {t('cookies.manager.unusedNote')}
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{ mr: 2 }}
        >
          {t('cookies.manager.save')}
        </Button>
        <Button
          variant="contained"
          onClick={handleRejectAll}
        >
          {t('cookies.manager.reject')}
        </Button>
      </Box>
    </Box>
  );
};

export default CookieManager; 